module.exports = __webpack_public_path__ + "static/media/ui-ux.9ff926bf.png";